'use client';

import PageBodyBuilder from '~/ui-modules/PageBodyBuilder';

import { LandingPageProps } from '../../../utils/landingPage';

export const LandingPage = ({
  jsonLD,
  pageData,
  reviews,
  brands,
}: LandingPageProps) => {
  if (!pageData?.metadata?.modules) return null;

  return (
    <PageBodyBuilder
      data={pageData}
      reviews={reviews}
      brands={brands}
      jsonLdContentArr={jsonLD ? [JSON.stringify(jsonLD)] : undefined}
      isBlog
    />
  );
};
